import usFlag from "../assets/images/flags/us.jpg"
import thai from "../assets/images/flags/thai.jpg"

const languages = {
  th: {
    label: "Thai",
    flag: thai,
  },
  en: {
    label: "English",
    flag: usFlag,
  },
}

export default languages
